import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref, computed, onMounted, watch } from 'vue';
import request from '@/utils/request'



export default /*#__PURE__*/_defineComponent({
  __name: 'CpePlatformSearch',
  props: {
  modelValue: {
    type: [String, Array],
  },
  mode: {
    type: String,
    default: '',
  },
},
  emits: ['update:modelValue', 'changeValues'],
  setup(__props, { emit: __emit }) {

const cpePlatforms = ref([])

const props = __props

const emits = __emit

const value: any = computed({
  set(val) {
    emits('update:modelValue', val)
  },
  get() {
    return props.modelValue
  },
})
onMounted(async () => {
  await handleGetCpePlatforms()
})


async function handleGetCpePlatforms() {
  try {
    const res = await request.get(`/api/in/kol/cpe/admin/project/get_cpe_platform`)
    cpePlatforms.value = res.data
  } catch(err) {
    console.log('err')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: value.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    mode: __props.mode
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cpePlatforms.value, (i) => {
        return (_openBlock(), _createBlock(_component_a_select_option, {
          value: i,
          key: i
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(i), 1)
          ]),
          _: 2
        }, 1032, ["value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "mode"]))
}
}

})